(function () {
  const MOUNT_ID = "cozify-supported-devices";
  const DATA_SRC = "https://www.cozify.fi/cdn/shop/t/2/assets/supported_devices_data_en.js?v=2026-09-21-12";
  const DATA_SCRIPT_ID = "cozify-supported-devices-data";

  function whenReady(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function loadScriptOnce(src, id) {
    return new Promise((resolve, reject) => {
      const existing = document.getElementById(id);
      if (existing) {
        if (existing.dataset.loaded === "1") return resolve();
        existing.addEventListener("load", () => resolve(), { once: true });
        existing.addEventListener(
          "error",
          () => reject(new Error("Script failed: " + src)),
          { once: true }
        );
        return;
      }

      const s = document.createElement("script");
      s.src = src;
      s.id = id;
      s.async = true;
      s.defer = true;

      s.addEventListener(
        "load",
        () => {
          s.dataset.loaded = "1";
          resolve();
        },
        { once: true }
      );

      s.addEventListener(
        "error",
        () => reject(new Error("Script failed: " + src)),
        { once: true }
      );

      document.head.appendChild(s);
    });
  }

  function dataReady() {
    return (
      Array.isArray(window.SUPPORTED_DEVICES) &&
      Array.isArray(window.CATEGORIES) &&
      window.LABELS &&
      typeof window.LABELS === "object"
    );
  }

  /**
   * Injects the filters UI + listing container into the mount.
   * Freshdesk may strip <input>/<select> from article HTML, so we create them via JS.
   * This is idempotent (won't duplicate if already present).
   */
  function ensureSupportedDevicesUI(mount) {
    if (!mount) return false;

    // If already present, do nothing
    if (
      document.getElementById("filters") &&
      document.getElementById("cozify-supported-devices-listing")
    ) {
      return true;
    }

    // Clear mount so we don't get partial leftovers
    // (Optional; remove this line if you want to preserve any static text around it.)
    mount.innerHTML = "";

    // --- Filters container ---
    const filters = document.createElement("div");
    filters.id = "filters";

    const h3 = document.createElement("h3");
    h3.textContent = "Filter the supported devices list";
    filters.appendChild(h3);

    const h5a = document.createElement("h5");
    h5a.textContent = "By Cozify device:";
    filters.appendChild(h5a);

    function addCheckbox(value, labelText, checked) {
      const label = document.createElement("label");

      const input = document.createElement("input");
      input.type = "checkbox";
      input.value = value;
      input.checked = !!checked;

      label.appendChild(input);
      label.appendChild(document.createTextNode(" " + labelText));

      filters.appendChild(label);
      //filters.appendChild(document.createElement("br"));
    }

    addCheckbox("hub", "Cozify HUB", true);
    addCheckbox("ion", "Cozify ION", true);
    addCheckbox("zen", "Cozify ZEN / DIN", true);
    addCheckbox("han", "Cozify HAN", true);

    const h5b = document.createElement("h5");
    h5b.textContent = "By device category:";
    filters.appendChild(h5b);

    const select = document.createElement("select");
    select.id = "categoryFilter";
    filters.appendChild(select);

    filters.appendChild(document.createElement("br"));

    const resetBtn = document.createElement("button");
    resetBtn.id = "resetFilters";
    resetBtn.type = "button";
    resetBtn.textContent = "Show all supported devices (no filters)";
    filters.appendChild(resetBtn);

    // --- Listing container ---
    const listing = document.createElement("div");
    listing.id = "cozify-supported-devices-listing";

    // Mount everything
    mount.appendChild(filters);
    mount.appendChild(listing);

    return true;
  }

  function initSupportedDevices() {
    // Guard: run only on the intended page
    const mount = document.getElementById(MOUNT_ID);
    if (!mount) return;

    const start = () => {
      if (!dataReady()) return;

      // Ensure UI exists (Freshdesk-safe)
      if (!ensureSupportedDevicesUI(mount)) return;

      const ALL_TOKENS = ["hub", "ion", "zen", "han"];
      const URL_SUPPORT_PARAM = "supportedBy";
      const URL_CATEGORY_PARAM = "category";

      function getSelectedSupportTokensFromUI() {
        return Array.from(
          document.querySelectorAll('#filters input[type="checkbox"]:checked')
        ).map(cb => cb.value);
      }

      function getSelectedCategoryFromUI() {
        const select = document.getElementById("categoryFilter");
        return select ? (select.value || null) : null;
      }

      function applyTokensToUI(tokens) {
        const t = tokens ?? ALL_TOKENS;
        document
          .querySelectorAll('#filters input[type="checkbox"]')
          .forEach(cb => {
            cb.checked = t.includes(cb.value);
          });
      }

      function applyCategoryToUI(categoryId) {
        const sel = document.getElementById("categoryFilter");
        if (sel) sel.value = categoryId || "";
      }

      function deviceMatchesTokens(device, tokens) {
        if (!tokens.length) return false;
        const supported = device.supportedBy || [];
        return tokens.some(t => supported.includes(t));
      }

      function parseSupportedByFromUrl() {
        const p = new URLSearchParams(location.search);
        if (!p.has(URL_SUPPORT_PARAM)) return null;
        return p
          .get(URL_SUPPORT_PARAM)
          .split(",")
          .map(v => v.trim())
          .filter(v => ALL_TOKENS.includes(v));
      }

      function parseCategoryFromUrl() {
        const p = new URLSearchParams(location.search);
        const v = p.get(URL_CATEGORY_PARAM);
        return v ? v.trim() : null;
      }

      function syncUrl(tokens, category) {
        const url = new URL(location.href);

        if (tokens.length === ALL_TOKENS.length)
          url.searchParams.delete(URL_SUPPORT_PARAM);
        else url.searchParams.set(URL_SUPPORT_PARAM, tokens.join(","));

        if (!category) url.searchParams.delete(URL_CATEGORY_PARAM);
        else url.searchParams.set(URL_CATEGORY_PARAM, category);

        history.replaceState({}, "", url);
      }

      function initCategoryFilter() {
        const select = document.getElementById("categoryFilter");
        if (!select) return;

        if (select.dataset.initialized === "1") return;
        select.dataset.initialized = "1";

        select.innerHTML = "";

        const allOpt = document.createElement("option");
        allOpt.value = "";
        allOpt.textContent = "All categories";
        select.appendChild(allOpt);

        window.CATEGORIES.forEach(c => {
          const o = document.createElement("option");
          o.value = c.id;
          o.textContent = c.name;
          select.appendChild(o);
        });
      }

      function renderSupportedDevices() {
        const root = document.getElementById("cozify-supported-devices-listing");
        if (!root) return;
        root.innerHTML = "";

        const tokens = getSelectedSupportTokensFromUI();
        const selectedCategory = getSelectedCategoryFromUI();

        const totalsByCategory = {};
        window.SUPPORTED_DEVICES.forEach(d => {
          totalsByCategory[d.category] =
            (totalsByCategory[d.category] || 0) + 1;
        });

        const filteredByCategory = {};
        window.SUPPORTED_DEVICES.forEach(d => {
          if (selectedCategory && d.category !== selectedCategory) return;
          if (!deviceMatchesTokens(d, tokens)) return;
          (filteredByCategory[d.category] ||= []).push(d);
        });

        const categoriesToRender = selectedCategory
          ? window.CATEGORIES.filter(c => c.id === selectedCategory)
          : window.CATEGORIES;

        const withResults = [];
        const withoutResults = [];

        categoriesToRender.forEach(cat => {
          const count = (filteredByCategory[cat.id] || []).length;
          (count > 0 ? withResults : withoutResults).push(cat);
        });

        [...withResults, ...withoutResults].forEach(cat => {
          const total = totalsByCategory[cat.id] || 0;
          const devices = filteredByCategory[cat.id] || [];

          const h3 = document.createElement("h3");
          h3.id = cat.id;
          h3.textContent = `${cat.name} (${devices.length} / ${total})`;
          root.appendChild(h3);

          if (!devices.length) {
            const p = document.createElement("p");
            p.className = "no-results";
            p.textContent = "No supported devices with the selected filters.";
            root.appendChild(p);
          } else {
            const dl = document.createElement("dl");

            devices.forEach(d => {
              const dt = document.createElement("dt");

              // Device name as a link when URL is provided
              if (d.url) {
                const a = document.createElement("a");
                a.href = d.url;
                a.target = "_blank";
                a.rel = "noopener noreferrer";
                a.textContent = d.device;
                dt.appendChild(a);
              } else {
                dt.appendChild(document.createTextNode(d.device));
              }

              // Optional suffix in its own tag for styling
              if (d.suffix) {
                const suf = document.createElement("span");
                suf.className = "suffix";
                suf.textContent = d.suffix;
                //dt.appendChild(document.createTextNode(" "));
                dt.appendChild(suf);
              }

              const dd = document.createElement("dd");
              (d.supportedBy || []).forEach(t => {
                const s = document.createElement("span");
                s.className = t;
                s.textContent = window.LABELS[t] || t;
                dd.appendChild(s);
              });

              dl.appendChild(dt);
              dl.appendChild(dd);
            });

            root.appendChild(dl);
          }

          if (window.CATEGORY_EXTRAS && window.CATEGORY_EXTRAS[cat.id]) {
            window.CATEGORY_EXTRAS[cat.id].forEach(extra => {
              const p = document.createElement("p");
              p.className = "category-extra";
              if (extra && typeof extra === "object") {
                if (extra.html) p.innerHTML = extra.html;
                else if (extra.text) p.textContent = extra.text;
              } else {
                p.textContent = String(extra);
              }
              root.appendChild(p);
            });
          }
        });

        syncUrl(tokens, selectedCategory);
      }

      // Wire UI once (after injection)
      const filters = document.getElementById("filters");
      const resetBtn = document.getElementById("resetFilters");

      if (filters && filters.dataset.wired !== "1") {
        filters.dataset.wired = "1";
        filters.addEventListener("change", renderSupportedDevices);
      }

      if (resetBtn && resetBtn.dataset.wired !== "1") {
        resetBtn.dataset.wired = "1";
        resetBtn.addEventListener("click", () => {
          applyTokensToUI();
          applyCategoryToUI();
          renderSupportedDevices();
        });
      }

      initCategoryFilter();
      applyTokensToUI(parseSupportedByFromUrl());
      applyCategoryToUI(parseCategoryFromUrl());
      renderSupportedDevices();
    };

    if (dataReady()) {
      start();
      return;
    }

    // Load data only on this page
    loadScriptOnce(DATA_SRC, DATA_SCRIPT_ID)
      .then(() => start())
      .catch(() => {
        // Fail silently in production
      });
  }

  whenReady(initSupportedDevices);
})();